import { analyzeAndValidateNgModules } from '@angular/compiler';
import { importType } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/shared.service';
import swal from 'sweetalert';

import { EmployeeComponent } from '../employee/employee.component';


@Component({
  selector: 'app-attendance-view',
  templateUrl: './attendance-view.component.html',
  styleUrls: ['./attendance-view.component.scss']
})
export class AttendanceViewComponent implements OnInit {

  constructor(private service: SharedService) { }

  attendanceList: any = [];

  ModalTitle: any;
  activateAddEditAttendance: boolean = false;
  attend: any;

  empId!: number;
  employeeName!: string;


  ngOnInit(): void {
    this.service.CurrentEmpId.subscribe(data => this.empId = data);
    this.RefreshAttendanceList();
    if(this.empId != undefined){
      this.GetEmployeeName(this.empId);
    }
  }


  RefreshAttendanceList() {
    this.service.GetAllEmployeeAttendance(this.empId).subscribe(data => {
      this.attendanceList = data;
    })
  }


  AddClick() {
    this.attend =
    {
      fkEmpId: 0
    }
    this.ModalTitle = "Enter New Attendance Record";
    this.activateAddEditAttendance = true;
  }


  EditClick(item: any) {
    this.attend = item;
    this.ModalTitle = "Edit Attendance Record";
    this.activateAddEditAttendance = true;
  }


  CloseClick() {
    this.activateAddEditAttendance = false;
    this.RefreshAttendanceList();
  }


  DeleteClick(item: any)
  {
    swal(
    {
      title: "Are you sure?",
      text: "Deleting this record may be irreversible.",
      icon: "warning",
      buttons: ["Cancel", "Ok"],
      dangerMode: true,
    })
    .then((willDelete) =>
    {
      if (willDelete)
      {
        this.service.DeleteAttendance(item.pkAttendanceId).subscribe(data =>
        {
          swal(data.toString(),
          {
            icon: "success",
          });
          this.RefreshAttendanceList();
        });
      }
    });
  }


  GetEmployeeName(id: any) {
    this.service.GetEmployee(id).subscribe(data => {
      this.employeeName = data[0]['FirstName'];
    });
  }
}
